// src/config/api.js
// Fonte ÚNICA da base URL do backend FastAPI. Nenhum outro arquivo do app pode
// escrever uma URL de backend literal.
//
// Contexto (17/08/2026): até esta data seis arquivos repetiam a URL do Render,
// quatro deles sem nenhum override de env. Como o CRA inlina
// `process.env.REACT_APP_*` no bundle em tempo de BUILD, cada binário publicado
// nas lojas saiu com a URL cravada dentro — e binário instalado não se corrige
// por painel. É por isso que o serviço do Render segue no ar como proxy: ele
// atende os apps antigos.
//
// O valor é o DOMÍNIO PRÓPRIO, nunca a URL da hospedagem. Uma URL de host
// (`*.onrender.com`, `*.run.app`) amarra cada binário publicado à infra vigente
// no dia do build; com `api.lesvita.com`, trocar de infra é trocar o DNS e
// nenhum app, painel ou link precisa ser tocado. Esta é a lição das duas
// migrações anteriores — não repita host aqui.
//
// Regra: para mudar o backend, mude a env de build (.env / .env.production*) e
// publique um release novo. O fallback abaixo só cobre build sem env definida.

const API_DOMAIN = "https://api.lesvita.com";

/**
 * Base URL do backend, sem barra final (evita `//rota` ao concatenar).
 * @type {string}
 */
export const API_BASE_URL = (
  process.env.REACT_APP_API_URL || API_DOMAIN
).replace(/\/+$/, "");

/**
 * Monta a URL completa de uma rota do backend.
 * @param {string} path caminho começando com "/" (ex.: "/pay/stripe/prices")
 * @returns {string}
 */
export function apiUrl(path) {
  return `${API_BASE_URL}${path.startsWith("/") ? path : `/${path}`}`;
}

export default API_BASE_URL;
